import { useEffect } from "react";

// External Portal v2 §4.3 FL-18 — re-fetch on tab focus / window focus.
// Subscribes to the document's visibilitychange + the window's focus
// event so a stale dashboard tab refreshes once the user comes back to
// it (mobile Safari typically fires `visibilitychange`; desktop fires
// `focus` first).

export function useRefetchOnVisible(refetch: () => void) {
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") refetch();
    };
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", refetch);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", refetch);
    };
  }, [refetch]);
}
